import React from 'react'
import tw from 'twin.macro'
import { graphql } from 'gatsby'
import RichText from '@/components/ui/rich-text'
import HubSpotForm from '@/components/ui/hubspot-form'
import HubiloForm from '@/components/ui/hubilo-form'
import { RenderRichTextData, ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'
import colors from '@/constants/colors'
import { extractDataAttributes } from '@/utils/dom'


export const fragment = graphql`
  fragment SectionForm on ContentfulSectionForm {
    id
    __typename
    headline
    body {
      raw
      #  references {
      #    ...Link
      #  }
    }
    form {
      ... on ContentfulComponentHubSpotForm {
        ...HubSpotForm
      }
      ... on ContentfulComponentHubiloForm {
        ...HubiloForm
      }
    }
    anchorId
    hideInitially
    backgroundColor
  }
`

export type Props = {
  headline?: string
  body?: RenderRichTextData<ContentfulRichTextGatsbyReference>
  form: any
  anchorId?: string
  hideInitially?: boolean
  backgroundColor?: string
}

export default function Form({
  backgroundColor,
  headline,
  body,
  form,
  anchorId,
  hideInitially,
  ...rest
}: Props): JSX.Element {
  const dataAttributes = extractDataAttributes(rest)
  const { white, primaryBlue, lightGray } = colors
  return (
    <section tw="max-w-8xl px-5 lg:px-9 mx-auto" css={[hideInitially && tw`hidden`]} id={anchorId} {...dataAttributes}>
      <div
        tw="rounded-4xl"
        css={[
          backgroundColor === white && tw`bg-white`,
          backgroundColor === primaryBlue && tw`bg-primaryBlue`,
          backgroundColor === lightGray && tw`bg-gray-100`,
        ]}
      >
        <div tw="mx-auto max-w-[800px] w-full py-12 px-5 ">
          <div tw="px-5">
            {headline && <h3 tw="text-center">{headline}</h3>}
            {body && (
              <div tw="text-center max-w-3xl mx-auto mb-12">
                <RichText body={body} />
              </div>
            )}
          </div>

          {form?.__typename === 'ContentfulComponentHubSpotForm' && <HubSpotForm {...form} />}
          {form?.__typename === 'ContentfulComponentHubiloForm' && <HubiloForm {...form} />}
        </div>
      </div>
    </section>
  )
}
